import { useState, useEffect } from "react";

const useMobilePlatform = () => {
  const [platform, setPlatform] = useState(null);

  useEffect(() => {
    if (typeof navigator === "undefined") return;

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const isIOS =
      /iPad|iPhone|iPod/.test(userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    const isAndroid = /android/i.test(userAgent);

    if (isIOS) setPlatform("ios");
    else if (isAndroid) setPlatform("android");
  }, []);

  return platform;
};

export default useMobilePlatform;
